<template>
  <div class="performance">
    <div class="box">
      <div class="box_1">
        <div>
          <img src="../../assets/rectangle.png" alt />
          <span class="rectangleSpan">测评表答题详情</span>
        </div>
        <div>
          <el-button round type="danger" class="back" @click="btnBack"
            >返回</el-button
          >
        </div>
      </div>
      <div class="grade_box3_one">
        <div
          class="grade_box3_one_exer"
          v-for="item in questionInfos"
          :key="item.ids"
        >
          <div class="exer">{{ item.name }}</div>
          <div v-if="item.type == '回答问题'" class="textNum">
            {{ item.nums }}
          </div>
          <div v-else class="exerciseBig">
            <div class="exerciseOne">
              <div class="textA" :class="{ checked: item.nums == 'A' }">A</div>
            </div>
            <div class="exerciseOne">
              <div class="textA" :class="{ checked: item.nums == 'B' }">B</div>
            </div>
            <div class="exerciseOne">
              <div class="textA" :class="{ checked: item.nums == 'C' }">C</div>
            </div>
            <div
              class="exerciseOne"
              v-if="
                item.type == '左右四项' ||
                item.type == '左右六项' ||
                item.type == '左右五项' ||
                item.type == '四项' ||
                item.type == '五项' ||
                item.type == '六项'
              "
            >
              <div class="textA" :class="{ checked: item.nums == 'D' }">D</div>
            </div>
            <div
              class="exerciseOne"
              v-if="
                item.type == '左右六项' ||
                item.type == '左右五项' ||
                item.type == '五项' ||
                item.type == '六项'
              "
            >
              <div class="textA" :class="{ checked: item.nums == 'E' }">E</div>
            </div>
            <div
              class="exerciseOne"
              v-if="item.type == '左右六项' || item.type == '六项'"
            >
              <div class="textA" :class="{ checked: item.nums == 'F' }">F</div>
            </div>
          </div>
        </div>
        <div class="grade_box3_two">
          <div class="grade_box3_two_left">
            <div class="top">作答</div>
            <div>情形</div>
          </div>
          <div class="grade_box3_two_right">
            <div class="grade_box3_two_right_box1">
              <div>
                <span>1.</span>
                <input type="checkbox" />
                <span>反应良好</span>
              </div>
              <div class>
                <span>2.</span>
                <input type="checkbox" class="inputbox3" />
                <span>反应迟钝</span>
              </div>
              <div class>
                <span>3.</span>
                <input type="checkbox" />
                <span>无反应</span>
              </div>
              <div class>
                <span>4.</span>
                <input type="checkbox" />
                <span>容易分心</span>
              </div>
              <div class>
                <span>5.</span>
                <input type="checkbox" />
                <span>其他</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'performance',
  components: {},
  props: {},
  data() {
    return {
      questionInfos: [],
      checkList: []
    };
  },
  created() {
    this.questionInfosList();
  },
  mounted() {},
  watch: {},
  computed: {},
  methods: {
    questionInfosList() {
      this.questionInfos = JSON.parse(sessionStorage.getItem('questionInfos'));
      console.log(this.questionInfos);
    },
    btnBack() {
      this.$router.go(-1);
    }
  }
};
</script>
<style lang="scss" scoped>
.performance {
  background-image: url('~@/assets/appraisal.png'); // 设置背景图片
  background-attachment: fixed;
  background-position: center;
  // background-size: 100% 100%;
  background-size: cover;
  // height: 100%;
  background-repeat: no-repeat;
  display: flex;
  flex-direction: column;
  align-items: center;
  //   padding-top: 33px;
  padding-bottom: 30px;

  //   height: 100vh;
  .box {
    margin-top: 33px;
    width: 1200px;
    background-color: #fff;
    border-radius: 10px;
    display: flex;
    flex-direction: column;
    // align-content: flex-start;
    // flex-wrap: wrap;
    padding-top: 49px;
    padding-left: 21px;
  }
}
.rectangleSpan {
  margin-left: 15px;
  font-size: 24px;
}
.grade_box3_one {
  height: 1500px;
  margin-top: 20px;

  display: flex;
  flex-direction: column;
  align-content: flex-start;
  flex-wrap: wrap;
}
.grade_box3_one_exer {
  display: flex;
  // justify-content: center;
  align-items: center;
  margin-bottom: 10px;
  width: 400px;
  height: 32px;
  .exer {
    font-size: 20px;
    margin-right: 20px;
  }
}
.textNum {
  font-size: 20px;
  margin-top: 2px;
}
.exerciseBig {
  display: flex;
}
.exerciseOne {
  margin-left: 10px;
  width: 33px;
  height: 33px;
  border: 1px solid #458af4;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
}
.textA {
  text-align: center; /* 可选 */
  color: #458af4;
}
.checked {
  width: 33px;
  height: 33px;
  border-radius: 50%;
  background-color: #458af4;
}
.box_1 {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.back {
  margin-right: 30px;
}
.grade_box3_two {
  width: 321px;
  height: 203px;
  background-color: #dfecff;
  border-radius: 10px;
  color: #458af4;
  margin-top: 80px;
  display: flex;
}
.grade_box3_two_left {
  width: 80px;
  height: 100%;
  font-size: 22px;
  //   background-color: azure;
  text-align: center;
  border-right: 1px solid #458af4;
  .top {
    padding: 55px 0;
  }
}
.grade_box3_two_right_box1 {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  font-size: 20px;
  line-height: 30px;
  margin-left: 20px;
}
input[type='checkbox'] {
  width: 16px;
  height: 16px;
  border: 1px solid #458af4;
  margin-left: 5px;
  margin-right: 8px;
}
</style>